<template>
    <v-row class="align-center">
        <v-col cols="12" md="6">
            <div class="d-flex align-center">
                <v-autocomplete
                    :outlined="outlined"
                    :dense="outlined"
                    v-if="editable"
                    :clearable="canPriceBeEdited"
                    :disabled="!!productprovider.id"
                    :error-messages="errors.provider"
                    :items="providersChoices"
                    :label="$translate('provider')"
                    :menu-props="{ closeOnClick: true }"
                    :required="true"
                    :value="productprovider.provider"
                    @input="updateProviderId($event)"
                    class="flex-grow-1"
                    hide-details
                    ref="provider"
                />

                <Field
                    v-else
                    :distabled="true"
                    class="flex-grow-1"
                    :value="productprovider?.provider_data?.name"
                    :label="$translate('provider')"
                    :disabled="true"
                    :error-messages="errors.provider"
                    :options="providersChoices"
                />
                <v-btn
                    :class="{ 'mt-5': outlined }"
                    text
                    v-if="productprovider.provider"
                    @click="
                        routerPush({
                            name: 'provider',
                            params: { provider_id: productprovider.provider },
                        })
                    "
                    ><v-icon>mdi-open-in-new</v-icon></v-btn
                >
            </div>
        </v-col>
        <v-col cols="12" md="6">
            <div class="d-flex align-center">
                <v-text-field
                    :outlined="outlined"
                    :dense="outlined"
                    class="flex-grow-1"
                    :value="productprovider.unit_amount"
                    :label="
                        productprovider.provider_data?.prices_include_vat
                            ? $translate('buyingPriceInclVat')
                            : $translate('buyingPriceExclVat')
                    "
                    type="text"
                    inputmode="decimal"
                    :clearable="canPriceBeEdited"
                    hide-details=""
                    :disabled="!canPriceBeEdited"
                    :error-messages="errors.unit_amount"
                    @change="
                        updateProviderProductPrice(
                            parseFloat($utils.normalizeDecimalString($event))
                        )
                    "
                />
                <v-btn :class="{ 'mt-5': outlined }" text @click="$emit('remove')" v-if="canBeDeleted"
                    ><v-icon>delete</v-icon></v-btn
                >
            </div>
        </v-col>
        <template v-if="errors.non_field_errors">
            <Warning :key="error" v-for="error in errors.non_field_errors">
                {{ error }}
            </Warning>
        </template>
    </v-row>
</template>

<script>
import ProviderEdit from "@/modals/provider";
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    props: {
        outlined: { type: Boolean, default: false },
        productprovider: {
            type: Object,
            required: true,
        },
        productproviders: {
            type: Array,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: true,
        },
        providers: {
            type: Array,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
        allowCreateProvider: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        updateProviderId(provider_id) {
            if (provider_id == "new") {
                this.showModal({
                    component: ProviderEdit,
                    params: {
                        provider: {},
                    },
                }).then((provider) => {
                    if (provider) {
                        this.$emit("provider-created", provider);
                    } else {
                        this.$refs.provider.internalValue = this.productprovider.provider;
                        return;
                    }
                    this.$emit("input", {
                        ...this.productprovider,
                        provider: provider.id,
                    });
                });
            } else {
                const provider = this.providers.find((p) => p.id === provider_id);
                this.$emit("input", {
                    ...this.productprovider,
                    provider: provider_id,
                    provider_data: provider,
                });
            }
        },
        updateProviderProductPrice(unit_amount) {
            if (!unit_amount) {
                unit_amount = null;
            }
            this.$emit("input", { ...this.productprovider, unit_amount });
        },
    },
    data() {
        return {
            provider_id: this.productprovider.provider,
        };
    },
    computed: {
        providersChoices() {
            if (this.productprovider?.id) {
                return [
                    {
                        isDisabled: true,
                        value: this.productprovider.provider,
                        text: this.productprovider.provider_data.name,
                    },
                ];
            }

            let choices = this.providers.map((item) => ({
                value: item.id,
                text: item.name,
            }));

            if (this.allowCreateProvider) {
                return [
                    {
                        value: "new",
                        text: this.$translate("createNewProvider"),
                    },
                ].concat(choices);
            }
            return choices;
        },
        canBeDeleted() {
            return this.editable && this.userHasPermission("catalog.delete_providercatalogentry");
        },
        canPriceBeEdited() {
            if (this.productprovider.id) {
                return (
                    this.editable && this.userHasPermission("catalog.change_providercatalogentry")
                );
            }
            return (
                this.editable &&
                this.productprovider.provider &&
                this.userHasPermission("catalog.add_providercatalogentry")
            );
        },
    },
    i18n: {
        messages: {
            en: {
                provider: "Provider",
                buyingPriceInclVat: "Buying price incl. VAT (in euros, optional)",
                buyingPriceExclVat: "Buying price excl. VAT (in euros, optional)",
                createNewProvider: "Create new provider",
            },
            fr: {
                provider: "Fournisseur",
                buyingPriceInclVat: "Prix d'achat TTC (en euros, optionnel)",
                buyingPriceExclVat: "Prix d'achat HT (en euros, optionnel)",
                createNewProvider: "Créer un fournisseur",
            },
        },
    },
};
</script>
